<div class="container-fluid p-2 p-md-3 px-0">
  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <h2 class="mb-0"><i class="bi bi-shield-lock me-2"></i>Gestione Organizzazioni</h2>
    <button
      class="btn btn-primary"
      [routerLink]="canCreate() ? '/organizations/add' : null"
      [queryParams]="canCreate() ? { from: 'manage' } : null"
      [disabled]="!canCreate()"
      [title]="canCreate() ? '' : 'Non hai i permessi per questa azione'">
      <i class="bi bi-plus-lg me-1"></i>Organizzazione
    </button>
  </div>

  @if (isLoading()) {
    <div class="text-center py-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
    </div>
  } @else if (organizations().length > 0) {
    <!-- Desktop: tabella (da md in su) -->
    <div class="table-responsive d-none d-md-block">
      <table class="table table-hover align-middle">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Contatti</th>
            <th scope="col">Stato</th>
            <th scope="col" class="text-end">Azioni</th>
          </tr>
        </thead>
        <tbody>
          @for (organization of organizations(); track organization.id) {
            <tr>
              <td>
                <div class="fw-medium">
                  @if (organization.organizationLogo) {
                    <img
                      [src]="organization.organizationLogo"
                      alt="Logo"
                      class="me-2"
                      style="width: 24px; height: 24px; object-fit: contain;">
                  }
                  {{ organization.organizationName }}
                </div>
                @if (organization.organizationDescription) {
                  <div class="text-muted small text-truncate" style="max-width: 320px;">
                    {{ organization.organizationDescription }}
                  </div>
                }
              </td>
              <td>
                <div class="small">
                  @if (organization.organizationEmail) {
                    <div><i class="bi bi-envelope me-1"></i>{{ organization.organizationEmail }}</div>
                  }
                  @if (organization.organizationPhone) {
                    <div><i class="bi bi-telephone me-1"></i>{{ organization.organizationPhone }}</div>
                  }
                  @if (!organization.organizationEmail && !organization.organizationPhone) {
                    <span class="text-muted">—</span>
                  }
                </div>
              </td>
              <td>
                <span class="badge" [ngClass]="organization.organizationActive ? 'bg-success' : 'bg-secondary'">
                  {{ organization.organizationActive ? 'Attiva' : 'Inattiva' }}
                </span>
              </td>
              <td class="text-end text-nowrap">
                <button
                  class="btn btn-outline-primary btn-sm"
                  [routerLink]="canOpenEdit(organization) ? ['/organizations/edit', organization.id] : null"
                  [queryParams]="canOpenEdit(organization) ? { from: 'manage' } : null"
                  [disabled]="!canOpenEdit(organization)"
                  [title]="canOpenEdit(organization) ? '' : 'Non hai i permessi per questa azione'">
                  <i class="bi bi-pencil me-1"></i>Modifica
                </button>
                <button
                  class="btn btn-outline-danger btn-sm ms-1"
                  [disabled]="!canDelete(organization)"
                  [title]="canDelete(organization) ? '' : 'Non hai i permessi per questa azione'"
                  (click)="onDelete(organization)">
                  <i class="bi bi-trash me-1"></i>Elimina
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Mobile: card per organizzazione (sotto md) -->
    <div class="d-md-none d-flex flex-column gap-3">
      @for (organization of organizations(); track organization.id) {
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start justify-content-between gap-2">
              <div class="fw-medium d-flex align-items-center gap-2">
                @if (organization.organizationLogo) {
                  <img
                    [src]="organization.organizationLogo"
                    alt="Logo"
                    style="width: 24px; height: 24px; object-fit: contain; flex-shrink: 0;">
                }
                <span>{{ organization.organizationName }}</span>
              </div>
              <span class="badge" [ngClass]="organization.organizationActive ? 'bg-success' : 'bg-secondary'">
                {{ organization.organizationActive ? 'Attiva' : 'Inattiva' }}
              </span>
            </div>

            @if (organization.organizationDescription) {
              <div class="text-muted small mt-2">
                {{ organization.organizationDescription }}
              </div>
            }

            <div class="small mt-2 d-flex flex-column gap-1">
              @if (organization.organizationEmail) {
                <div><i class="bi bi-envelope me-2"></i>{{ organization.organizationEmail }}</div>
              }
              @if (organization.organizationPhone) {
                <div><i class="bi bi-telephone me-2"></i>{{ organization.organizationPhone }}</div>
              }
              @if (!organization.organizationEmail && !organization.organizationPhone) {
                <div class="text-muted">—</div>
              }
            </div>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button
                class="btn btn-outline-primary btn-sm"
                [routerLink]="canOpenEdit(organization) ? ['/organizations/edit', organization.id] : null"
                [queryParams]="canOpenEdit(organization) ? { from: 'manage' } : null"
                [disabled]="!canOpenEdit(organization)"
                [title]="canOpenEdit(organization) ? '' : 'Non hai i permessi per questa azione'">
                <i class="bi bi-pencil me-1"></i>Modifica
              </button>
              <button
                class="btn btn-outline-danger btn-sm"
                [disabled]="!canDelete(organization)"
                [title]="canDelete(organization) ? '' : 'Non hai i permessi per questa azione'"
                (click)="onDelete(organization)">
                <i class="bi bi-trash me-1"></i>Elimina
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="container-generic text-center py-5">
      <p class="message-error">Nessuna organizzazione trovata</p>
    </div>
  }
</div>
